const getDialogSize = (size) => {
  if (size) {
    return { width: '90vw', height: '90vh' };
  }
  return { width: '50vw', height: '70vh' };
};

export default getDialogSize;
